import React from 'react';
import { OrderProductItem } from '../../components/OrderProductItem/OrderProductItem';
import { IOrderProductComboItem } from 'src/types/orders';
import { productUtils } from '~/utils/productUtils';

interface IProps {
  items: IOrderProductComboItem[] | undefined;
  isMeal: boolean;
  productQuantity: number;
}

export const OrderProductItemsList: React.FC<IProps> = ({ items, isMeal, productQuantity }: IProps): JSX.Element | null => {
  if (!items?.length) return null;

  return (
    <div className="d-flex flex-column mt-4">
      {items.map((item, index) => (
        <OrderProductItem key={productUtils.getMealItemKey(item, index)} item={item} isMeal={isMeal} productQuantity={productQuantity} />
      ))}
    </div>
  );
};

export default OrderProductItemsList;
